import React, { useEffect, useState } from 'react'
import * as THREE from "three"
import { useTexture } from '@react-three/drei'
import { useSelector } from 'react-redux';
import { E_MainLato } from '../Utils/enumerations';

// Genera i piedini sotto alla pedana
export default function Piedini({altezzaPiedini, posizioneIngresso}) {
    const lunghezza = useSelector(state => state.uiMainMenu.lunghezza);
    const larghezza = useSelector(state => state.uiMainMenu.larghezza);
    const altezzaPedana = useSelector(state => state.uiPedanaMenu.stepAltezza);
    const hasRampaDisabili = useSelector(state => state.uiPedanaMenu.rampaDisabili);
    const latoIngresso = useSelector(state => state.uiMainMenu.ingresso);
    const dataOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.dataOmbrelloni);
    const ombrelloniIsVisible = useSelector(state => state.uiOmbrelloniMenu.isVisible);
    const genereOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.genereOmbrellone);
    const latoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.latoOmbrelloni);

    const radiusTop = 0.02;
    const radiusBottom = 0.022;
    const radialSegments = 30;
    const heightSegments = 2;

    const distanzaPiedini = 2;
    const offsetInterno = 0.15;
    const [piediniArrayPos, setPiediniArrayPos] = useState([]);
    const [piediniExtraArrayPos, setPiediniExtraArrayPos] = useState([]);
    const numeroPiedinExtraLung = Math.floor(lunghezza / distanzaPiedini);
    const numeroPiedinExtraLarg = Math.floor(larghezza / distanzaPiedini);

    // Calcola la distribuzione dei piedini a seconda della posizione dell'ingresso e della disposizione degli ombrelloni
    const calcolaPosizionePiedini = () => {      
        const piediniInLarghezza = (larghezza / distanzaPiedini);
        let tempPiediniArray = [];
        let tempExtraPiediniArray = []
        // Angolo E
        tempPiediniArray.push([lunghezza / 2 - offsetInterno, altezzaPiedini / 2, - larghezza / 2 + offsetInterno]);
        // Angolo S
        tempPiediniArray.push([lunghezza / 2 - offsetInterno, altezzaPiedini / 2, (piediniInLarghezza * distanzaPiedini) - larghezza / 2 - offsetInterno]);
        // Angolo O
        tempPiediniArray.push([-lunghezza / 2 + offsetInterno, altezzaPiedini / 2, (piediniInLarghezza * distanzaPiedini) - larghezza / 2 - offsetInterno]);
        // Angolo N
        tempPiediniArray.push([-lunghezza / 2 + offsetInterno, altezzaPiedini / 2, - larghezza / 2 + offsetInterno]);
        // PIEDINI SOTTO PEDANA
        // Larghezza pedana
        tempPiediniArray.push([lunghezza / 2 - offsetInterno, altezzaPiedini / 2, - 0.5 - offsetInterno / 2]);
        tempPiediniArray.push([lunghezza / 2 - offsetInterno, altezzaPiedini / 2, + 0.5 + offsetInterno / 2]);
        // Larghezza pedana
        tempPiediniArray.push([-lunghezza / 2 + offsetInterno, altezzaPiedini / 2, - 0.5 - offsetInterno / 2]);
        tempPiediniArray.push([-lunghezza / 2 + offsetInterno, altezzaPiedini / 2, 0.5 + offsetInterno / 2]);
        // Lunghezza sotto pedana
        tempPiediniArray.push([- 0.5 - offsetInterno / 2, altezzaPiedini / 2, - larghezza / 2 + offsetInterno]);
        tempPiediniArray.push([0.5 - offsetInterno / 2 + offsetInterno, altezzaPiedini / 2, - larghezza / 2 + offsetInterno]);
        // Lunghezza sotto pedana
        tempPiediniArray.push([- 0.5 - offsetInterno / 2, altezzaPiedini / 2, larghezza / 2 - offsetInterno]);
        tempPiediniArray.push([0.5 - offsetInterno / 2 + offsetInterno, altezzaPiedini / 2, larghezza / 2 - offsetInterno]);
        // Se il numero è maggiore della distanza piedini, piazza un piedino extra     
        if (lunghezza > distanzaPiedini * 2) {        
            // Quando piazza un nuovo piedino
            for (let i = 1; i < numeroPiedinExtraLung; i++) {
                tempExtraPiediniArray.push([i, altezzaPiedini / 2, larghezza / 2 - offsetInterno]);
                tempExtraPiediniArray.push([-i, altezzaPiedini / 2, larghezza / 2 - offsetInterno]);
                tempExtraPiediniArray.push([i, altezzaPiedini / 2, -larghezza / 2 + offsetInterno]);
                tempExtraPiediniArray.push([-i, altezzaPiedini / 2, -larghezza / 2 + offsetInterno]);
            }            
        }
        // Se il numero è maggiore della distanza piedini, piazza un piedino extra
        if (larghezza > distanzaPiedini * 2) {    
            // Quando piazza un nuovo piedino
            for (let i = 1; i < numeroPiedinExtraLarg; i++) {
                tempExtraPiediniArray.push([-lunghezza / 2 + offsetInterno, altezzaPiedini / 2, i]);
                tempExtraPiediniArray.push([-lunghezza / 2 + offsetInterno, altezzaPiedini / 2, -i]);
                tempExtraPiediniArray.push([lunghezza / 2 - offsetInterno, altezzaPiedini / 2, i]);
                tempExtraPiediniArray.push([lunghezza / 2 - offsetInterno, altezzaPiedini / 2, -i]);
            }         
        }
        // Elimina i piedini che sormontano la rampa disabili
        if (hasRampaDisabili) {
            if (latoIngresso.toString() === E_MainLato.Lato1.toString() || latoIngresso.toString() === E_MainLato.Lato3.toString()) {
                for (let i=0; i<tempExtraPiediniArray.length; i++) {
                    if (tempExtraPiediniArray[i][2] >= posizioneIngresso-0.5-radiusTop && tempExtraPiediniArray[i][2] <= posizioneIngresso+0.5+radiusTop) {
                        tempExtraPiediniArray.splice(i,1);                                 
                    }
                }
                for (let i=0; i<tempPiediniArray.length; i++) {
                    if (tempPiediniArray[i][2] >= posizioneIngresso-0.5-radiusTop && tempPiediniArray[i][2] <= posizioneIngresso+0.5+radiusTop) {
                        tempPiediniArray.splice(i,1);                                 
                    }
                }          
            }
            if (latoIngresso.toString() === E_MainLato.Lato2.toString() || latoIngresso.toString() === E_MainLato.Lato4.toString()) {
                for (let i=0; i<tempExtraPiediniArray.length; i++) {
                    if (tempExtraPiediniArray[i][0] >= posizioneIngresso-0.5-radiusTop && tempExtraPiediniArray[i][0] <= posizioneIngresso+0.5+radiusTop) {
                        tempExtraPiediniArray.splice(i,1);                                 
                    }
                }
                for (let i=0; i<tempPiediniArray.length; i++) {
                    if (tempPiediniArray[i][0] >= posizioneIngresso-0.5-radiusTop && tempPiediniArray[i][0] <= posizioneIngresso+0.5+radiusTop) {
                        tempPiediniArray.splice(i,1);                                 
                    }
                }          
            }
        }
        setPiediniArrayPos(tempPiediniArray);
        setPiediniExtraArrayPos(tempExtraPiediniArray);
    }

    useEffect(() => {
        calcolaPosizionePiedini();
    }, [lunghezza, larghezza, altezzaPedana, hasRampaDisabili, latoIngresso, dataOmbrelloni, ombrelloniIsVisible, genereOmbrelloni, latoOmbrelloni]);

    const woodCylindicalTexturesProps = useTexture({
        map: `${process.env.PUBLIC_URL}/textures/piedini/Wood_026_basecolor.jpg`,
        normalMap: `${process.env.PUBLIC_URL}/textures/piedini/Wood_026_normal.jpg`,
        roughnessMap: `${process.env.PUBLIC_URL}/textures/piedini/Wood_026_roughness.jpg`,
        aoMap: `${process.env.PUBLIC_URL}/textures/piedini/Wood_026_ambientOcclusion.jpg`,
    })

    woodCylindicalTexturesProps.map.repeat.set(1, 1);
    woodCylindicalTexturesProps.normalMap.repeat.set(1, 1);
    woodCylindicalTexturesProps.roughnessMap.repeat.set(1, 1);
    woodCylindicalTexturesProps.aoMap.repeat.set(1, 1);

    woodCylindicalTexturesProps.map.wrapS = woodCylindicalTexturesProps.map.wrapT = THREE.RepeatWrapping;
    woodCylindicalTexturesProps.normalMap.wrapS = woodCylindicalTexturesProps.normalMap.wrapT = THREE.RepeatWrapping;
    woodCylindicalTexturesProps.roughnessMap.wrapS = woodCylindicalTexturesProps.roughnessMap.wrapT = THREE.RepeatWrapping;
    woodCylindicalTexturesProps.aoMap.wrapS = woodCylindicalTexturesProps.aoMap.wrapT = THREE.RepeatWrapping;

    return (
        <group>
            {piediniArrayPos.map((pos, index) => <mesh position={pos} key={`piedino_${index}`}>
                <cylinderGeometry args={[radiusTop, radiusBottom, altezzaPiedini, radialSegments, heightSegments]} />
                <meshStandardMaterial {...woodCylindicalTexturesProps} color={0x7a6a6c} />
            </mesh>)}
            {piediniExtraArrayPos.map((pos, index) => <mesh position={pos} key={`piedinoExtra_${index}`}>
                <cylinderGeometry args={[radiusTop, radiusBottom, altezzaPiedini, radialSegments, heightSegments]} />
                <meshStandardMaterial {...woodCylindicalTexturesProps} color={0x7a6a6c} />
            </mesh>)} 
        </group>
    )
}
